import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { merge, Observable, of } from 'rxjs';
import { map, switchMap, catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root'
})
export class ExpWinAccountabilityService {

  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router) { }

  getExpWinAccountabilityData(): Observable<any> {

    var url = `${environment.scApiProtocol}://${environment.scApiHost}:${environment.scApiPort}/api/SantaCruz/DataMonitorExpWinAccountabilitySumGet`;

    const intitial$: Observable<any> = of({
      workingText: 'Loading Data...',
      errorMessage: undefined
    });

    const loader$ = this.route.params.pipe(
      switchMap(d => 
        this.http.get(url)
        .pipe(
          map((d: any) => d),
          catchError(error => of({
            isLoading: false, 
            isLoaded: false,
            isError: true,
            workingText: '',
            isFound: 0,
            errorText: error.error instanceof ErrorEvent ? `an error occurred: ${error.error.message}` : `backend error: ${error.status} - ${error.message}`,
            data: {}
          }))
        )
      ),
      //tap(d => console.log(d)),
      map(d => ({
        items: d.items,
        lastUpdated: d.lastUpdated,
        isNotFound: !d.items || d.items.length == 0,
        isLoading: false,
        isLoaded: true,
        isError: false,
        errorText: !d.success ? d.message : undefined,
        requiredGroups: d.requiredGroups,
        workingText: ''
      })),
      catchError((e, v) => of({ workingText: undefined, errorText: e.message ? e.message : e }))
    );

    return merge(intitial$, loader$);
  }

  getExpWinAccountabilityAcknowledgedCountData(): Observable<any> {

    var url = `${environment.scApiProtocol}://${environment.scApiHost}:${environment.scApiPort}/api/SantaCruz/DataMonitorExpWinAccountabilityAcknowledgedCountGet`;

    const intitial$: Observable<any> = of({
      workingText: 'Loading Data...',
      errorMessage: undefined
    });

    const loader$ = this.route.params.pipe(
      switchMap(d => 
        this.http.get(url)
        .pipe(
          map((d: any) => d),
          catchError(error => of({
            isLoading: false, 
            isLoaded: false,
            isError: true,
            workingText: '',
            isFound: 0,
            errorMessage: error.error instanceof ErrorEvent ? `an error occurred: ${error.error.message}` : `backend error: ${error.status} - ${error.message}`,
            data: {}
          }))
        )
      ),
      //tap(d => console.log(d)),
      map(d => ({
        items: d.items,
        lastUpdated: d.lastUpdated,
        isNotFound: d.items.length === 0,
        isLoading: false,
        isLoaded: true,
        isError: false,
        errorMessage: '',
        workingText: ''
      })),
      catchError((e, v) => of({ workingText: undefined, errorMessage: e.message ? e.message : e }))
    );

    return merge(intitial$, loader$);
  }
}
